import { getABTest, sendABTestAnalytics } from "../../../domain/abtest/abtest-provider";
import { getPersonalizationProperty } from '../../personalization/domain/personalization-provider';

/**
 * https://wavesaudio.atlassian.net/browse/MRKT-25058
 * list pages where URL like plugins or bundles, and persona = wca-prospect.
 * old:34, yellow-sbs:33, perpetual-link:33
 */
export const initButtonsABCDAbTest = () => {
    const abtest = getABTest('ProductListPricingArea99');
    if(!abtest?.isActive) return 'old';
    
    const pathname = window.location.pathname;
    const isCorrectUrl = pathname.startsWith('/bundles') ||
                                    pathname.startsWith('/plugins') ||
                                    pathname.startsWith('/new-products') ||
                                    pathname.startsWith('/best-sellers') ||
                                    pathname.startsWith('/specials');

    const isCorrectPersona = getPersonalizationProperty('persona') === 'wca-prospect';
    const isABTestShouldRun = isCorrectUrl && isCorrectPersona;

    if(!isABTestShouldRun) return 'old';

    sendABTestAnalytics(abtest);
    return abtest?.selected || 'old';
};